import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppSettingsAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"app_settings_alt"}/>
}
